import PARENT from '../types';

const PRIMARY_PARAMETER_LEVEL = `${PARENT}/PRIMARY_PARAMETER_LEVEL`;

export const SET_PRIMARY_PARAMETER_LEVEL = `${PRIMARY_PARAMETER_LEVEL}/SET`;

export default PRIMARY_PARAMETER_LEVEL;
